import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";

// Spinner Component
const Spinner = () => (
  <div className="flex items-center justify-center min-h-screen bg-black bg-opacity-90">
    <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-yellow-400 border-solid"></div>
  </div>
);

export function Books() {
  const [books, setBooks] = useState([]);
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = "/image/bg/Astrology__books.webp"; // Ensure correct path
    img.onload = () => setImageLoaded(true);
  }, []);

  useEffect(() => {
    fetch("/books.json")
      .then((response) => response.json())
      .then((data) => setBooks(data))
      .catch((error) => console.error("Error loading book data:", error));
  }, []);

  if (!books) {
    return <Spinner />;
  }

  return (
    <div
      style={{
        backgroundImage: imageLoaded ? "url('/image/bg/astrobook.webp')" : "none",
        backgroundSize: "cover",
        backgroundPosition: "center",
        opacity: imageLoaded ? 1 : 0,
      }}
      className="min-h-screen flex items-center justify-center mt-28 sm:mt-20"
    >
      <Helmet>
                    <title>Atyant Mangalkari bhi Hain Shanidev Kaise?</title>
                    <meta name="description" content="This complete astrology guide explores Vedic horoscope analysis, zodiac sign predictions, and planetary influence interpretations" />
                    <meta name="keywords" content="Complete astrology guide, Vedic horoscope analysis, Zodiac sign predictions, Birth chart components, Planetary dosha remedies" />
                    <meta property="og:title" content="Atyant Mangalkari bhi Hain Shanidev Kaise? || Astrology Book by pt. Akhileshwar sharma" />
                    <meta property="og:description" content="Discover personalized astrology services." />
                    <meta property="og:url" content="https://astromahamaya.com/books" />
      </Helmet>
      <div className="p-6 bg-yellow-500 bg-opacity-80 min-h-screen flex flex-col items-center justify-center w-full">
        <h1 className="text-4xl font-bold text-center text-black mt-16">
          📚 Astrology Books
        </h1>
        <p className="text-lg text-gray-800 text-center mb-4">
          Explore books on astrology and purchase from Amazon.
        </p>

        {/* Books Container */}
        <div className="w-full flex justify-center mt-5">
          <div
            className={`grid gap-6 ${
              books.length === 1 ? "grid-cols-1 place-items-center" : "grid-cols-1 md:grid-cols-2 lg:grid-cols-3"
            }`}
          >
            {books.map((book, index) => (
              <div
                key={index}
                className="bg-yellow-100 bg-opacity-80  p-6 rounded-xl shadow-lg text-center w-full max-w-sm transition-transform transform hover:scale-105 hover:bg-opacity-60 border border-black"
              >
                <img
                  src={book.image}
                  alt={book.title}
                  className="w-48 h-64 mx-auto rounded-lg shadow-md object-cover"
                />
                <h2 className="text-2xl font-bold text-black mt-4">
                  {book.title}
                </h2>
                <h2 className="text-lg font-bold text-black mt-2 border-b-2 border-black">
                  By - {book.author}
                </h2>
                <p className="text-sm text-gray-700 mt-2">{book.description}</p>
                <p className="text-sm text-gray-700 mt-2">{book.hindidescription}</p>
                <a
                  href={book.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-4 inline-block bg-yellow-500 hover:bg-yellow-600 text-black font-bold py-2 px-5 rounded-full transition duration-300"
                >
                  Purchase Book
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
